/*
*  All site copy - word for word from the Wix site (www.almans.co.za), including its original spelling.
*  Product names & pack sizes live in products.js
*/

export const SITE_NAME = "Alman's";
export const SITE_URL = "https://www.almans.co.za";
export const DEFAULT_DESCRIPTION = "Alman’s Dried Fruit and Nuts was founded in 1996 with the purpose of supplying South Africa with the widest variety of quality dried fruit and nuts from around the world.";

//Routes match the old Wix URLs so existing links & search results keep working
export const ROUTES = {
  HOME: "/",
  CONTACT: "/contact-us",
  FACILITY: "/our-facility",
  CERTIFICATION: "/certification",
};

//Sections on the home page (the Wix menu scrolled to these anchors)
export const SECTIONS = {
  ABOUT: "about",
  SERVICES: "services",
  RETAILERS: "retailers",
  PRODUCTS: "our-products",
};

export const NAV_LINKS = [
  { label: "Home", to: ROUTES.HOME },
  { label: "About", to: `${ROUTES.HOME}#${SECTIONS.ABOUT}` },
  { label: "Retailers", to: `${ROUTES.HOME}#${SECTIONS.RETAILERS}` },
  { label: "Our Products", to: `${ROUTES.HOME}#${SECTIONS.PRODUCTS}` },
  { label: "Our Facility", to: ROUTES.FACILITY },
  { label: "Certification", to: ROUTES.CERTIFICATION },
  { label: "Contact Us", to: ROUTES.CONTACT },
];

export const FOOTER_LINKS = [
  { label: "Home", to: ROUTES.HOME },
  { label: "Services", to: `${ROUTES.HOME}#${SECTIONS.SERVICES}` },
  { label: "Our Products", to: `${ROUTES.HOME}#${SECTIONS.PRODUCTS}` },
  { label: "Certifications", to: ROUTES.CERTIFICATION },
  { label: "Our Facility", to: ROUTES.FACILITY },
  { label: "Contact us", to: ROUTES.CONTACT },
];

export const CONTACT = {
  phones: [
    { display: "+27 11 397 4585", href: "tel:+27113974585" },
    { display: "+27 11 397 4686", href: "tel:+27113974686" },
  ],
  email: "almans@yebo.co.za",
  address: "226 Brakpan Road, Boksburg East, Johannesburg, South Africa",
  mapUrl: "https://www.google.com/maps/search/?api=1&query=226+Brakpan+Road,+Boksburg+East,+Johannesburg,+South+Africa",
  factoryShops: [
    "226 Brakpan Road, Boksburg East, Johannesburg",
    "16 Covora Road, Jet Park, Johannesburg",
  ],
  instagram: "https://www.instagram.com/almansdriedfruitandnuts/",
  facebook: "https://www.facebook.com/Almans-Dried-Fruit-And-Nuts-107565508408275",
};

export const HOME = {
  metaTitle: "Wholesale Nuts | South Africa",
  hero: "Here at Alman's, we are nuts about health and that's our promise from our family to yours.",
  about: {
    title: "ABOUT",
    paragraphs: [
      "Alman’s Dried Fruit and Nuts was founded in 1996 with the purpose of supplying South Africa with the widest variety of quality dried fruit and nuts from around the world. This never ending quest ensures our customers are enjoying the highest quality dried fruit and nuts.",
      "Over the 26 years, Alman’s has created a lifestyle solution for people who are passionate about health. Providing South Africa with the healthiest products sourced from around the world is still our dream and what gets us out of bed in the mornings.",
    ],
    mapAlt: "World map showing the countries Alman’s exports to and imports from",
    exportLabel: "Export",
    importLabel: "Import",
  },
  values: [
    {
      title: "Mission",
      text: "Our mission is to continuously learn and grown in order to meet the needs of all of our consumers. To maintain a long standing relationship with our suppliers and customers ensuing quality.",
    },
    {
      title: "Our Values",
      text: "Our relationships with our employees, suppliers and customers is most important. This stems from our strong focus on customer service.",
    },
    {
      title: "Purpose",
      text: "Our purpose from inception of the brand has been to supply South Africa with the widest variety of dried fruit, nuts and healthy snacks. This has grown into a goal of being the preferred supplier for the South African retail market as well as the international market place. We continuously strive to meet this never ending goal.",
    },
    {
      title: "Quality Control",
      text: "Our facility has and in house team ensuring product quality as well as employees safety. Almans is Kosher, Halaal, HACCAP as well as FSSC 22000 certified.",
    },
  ],
  services: [
    {
      title: "PRODUCTION",
      icon: "/images/icons/production.png",
      text: "All our nuts are dry roasted and contain zero oil. This is why our nuts are crispy, healthy and scrumptiously tasty.",
    },
    {
      title: "PACKAGING",
      icon: "/images/icons/packaging.png",
      text: "Alman’s houses over 180 different types and variants of nuts and dried fruits. All of our products are packaged by us with over 80 dedicated staff ensuring we do not miss a beat. We also provide packaging solutions and private label for South African and International retail brands.",
    },
    {
      title: "SUPPLYING TO RETAIL OUTLETS",
      icon: "/images/icons/retail.png",
      text: "We offer distribution and marketing expertise that help our customers make critical purchasing decisions and expand business. Our company has spent over 26 years building relations with our customers to ensure that all Alman’s is found in the majority of retail stores across South Africa.",
    },
    {
      title: "OUR FACTORY",
      icon: "/images/icons/factory.png",
      text: "With State of the art machinery and thousands of helping hands we have fine tuned our factory into what it is today.",
    },
  ],
  retailers: {
    title: "RETAILERS",
    logos: [
      { name: "West Pack Lifestyle", image: "/images/retailers/westpack.png" },
      { name: "SPAR", image: "/images/retailers/spar.png" },
      { name: "Pick n Pay", image: "/images/retailers/pick-n-pay.png" },
      { name: "Food Lover’s Market", image: "/images/retailers/food-lovers-market.png" },
      { name: "Dis-Chem Pharmacies", image: "/images/retailers/dis-chem.png" },
      { name: "Sasol", image: "/images/retailers/sasol.png" },
      { name: "Wellness Warehouse", image: "/images/retailers/wellness-warehouse.png" },
      { name: "Engen", image: "/images/retailers/engen.png" },
    ],
  },
  productsAndProcess: [
    {
      title: "OUR PRODUCTS",
      image: "/images/farm.jpg",
      text: "Alman’s imports high quality products from the United States, Canada, Mexico, Europe and the Middle East. Our reach is continuously expanding because of our loyal customer and supplier base who appreciate our quality service and products.",
    },
    {
      title: "OUR PROCESS",
      image: "/images/factory.jpg",
      text: "What separates us from the rest is the care and precision we take in transforming raw products into a crunchy moment of happiness.",
    },
  ],
  haccp: {
    heading: "Alman’s Dried Fruit and Nuts is HACCP certified and found to adequately comply with the requirements of:",
    text: "SANS 10049 requirements for prerequisite programmes (PRP’s); ISO/TS 22002 prerequisite programmes on food safety; Codex Hazard Analysis Critical Control Point (HACCP) principles; Food Safety management System requirements as guided by the Global Food Safety Initiative (GFSI); Applicable laws, regulations and Compulsory specifications.",
  },
  productsTitle: "OUR PRODUCTS",
};

export const CONTACT_PAGE = {
  metaTitle: "Contact Us",
  title: "Contact Us",
  success: "Thanks for submitting!",
  //Contact type drop-down - label & options as set up on the Wix form
  enquiryTypeLabel: "Choose an option",
  enquiryTypes: ["Order Query", "Private Label", "Whole Sale", "General"],
};

export const FACILITY_PAGE = {
  metaTitle: "Our Facility",
  title: "Our Facility",
  shopsHeading: "Visit our Factory Shops:",
  images: Array.from({ length: 19 }, (_, i) => {
    const n = String(i + 1).padStart(2, "0");
    return {
      full: `/images/facility/facility-${n}.jpg`,
      thumb: `/images/facility/thumbs/facility-${n}.jpg`,
      alt: `Alman’s factory and facility photo ${i + 1}`,
    };
  }),
};

export const CERTIFICATION_PAGE = {
  metaTitle: "Certification",
  title: "Certification",
  documents: [
    {
      name: "Kosher Certificate",
      image: "/images/certificates/kosher-certificate.png",
      file: "/documents/almans-kosher-certificate.pdf",
    },
    {
      name: "FSSC 22000 Certificate",
      image: "/images/certificates/fssc-22000-certificate.png",
      file: "/documents/almans-fssc-22000-certificate.pdf",
    },
    {
      name: "Kosher Letter",
      image: "/images/certificates/kosher-letter.png",
      file: "/documents/almans-kosher-letter.pdf",
    },
  ],
};

export const FOOTER = {
  copyright: "©2022 by Alman's.",
};
